<template>
  <div>
    <div class="navbar">
      <navbar :titlename="titlename"></navbar>
    </div>
    <van-overlay :show="show" @click="closecomment" />
    <div class="detailstop">
      <ddetailstop :messageList="messageList" :dqdtid="dqdtid" :isPidInfo="isPidInfo" :toName="toName" :listindex="listindex" @upCommentbig="upCommentbig" @initMyMssage="initMyMssage" :isTalk="show"></ddetailstop>
    </div>

    <div class="commentbox">
      <div class="commenthead">
        <div class="commenthead-tx">
          <span>转发及鼓掌</span>
          <div class="cu-avatar-group">
            <div class="cu-avatar round touxiangzu" v-for="(item,index) in messageList.new_see" :key="index" :style="{backgroundImage: 'url(' + item + ')'}"></div>
          </div>
        </div>
        <div class="commenthead-num">{{messageList.comment_num}}条评论</div>
      </div>

      <div class="commentbody">
        <div v-for="(item,idx) in commentList" :key="idx">
          <comment :item="item" :index="idx" :commentList="commentList" @upCommentbig="upCommentbig"></comment>
          <!--  <template
            is="comment-template"
            data="{{imageUrl,dianzanicon,dianzannum,...item,index,commentList,applauseicon,applauseicon02}}"
          />-->

          <!-- 回复评论 -->
          <div v-for="(item,index) in item.reply_info" :key="index">
            <recomment :item="item" :index="index" :commentList="commentList" :idx="idx" @upCommentbig="upCommentbig"></recomment>
            <!--  <template
              is="recomment-template"
              data="{{imageUrl,dianzanicon,dianzannum,...item,index,idx,applauseicon,applauseicon02}}"
            />-->
          </div>
        </div>
      </div>

      <!-- 小评论 -->
      <div class="commentinputbox" @click="upCommentbig" :data-toname="messageList.name" v-if="showsmallinput">
        <div class="cu-bar input cu-barbox">
          <div class="cu-avatar cu-bar-imgicon" style>
            <img src="../../assets/images/dynamic_btn_pic_normal.png" />
          </div>
          <span class="wztext">友善的评论是交流的起点…</span>
          <button class="cu-btn bg-green shadow-blur cu-btn-fsbtn">发布</button>
        </div>
      </div>

      <!--评论-->

      <form v-else>
        <div class="commentinputmain">
          <div class="com-input-head">
            <div class="com-input-head-img" @click.stop="bigtextarea">
              <img :src="inputHeadImg" />
            </div>
            <span class="com-input-head-text01">评论给</span>
            <span class="com-input-head-text02">{{toName}}</span>
          </div>
          <div class="com-input-textarea">
            <textarea v-model="content" name="content" maxlength="500" :style="'height:'+ textareaheight +'px'" placeholder="评论是交流的起点…" @input="verify"></textarea>
          </div>
          <div class="cu-form-group" v-if="imgList">
            <div class="grid col-4 grid-square flex-sub">
              <div class="bg-img" @click="ViewImage" :data-url="imgList">
                <img :src="imgList" />
                <img class="cu-tag" @click.stop="DelImg" src="../../assets/images/dynamic_icon_dtb.png" alt />
              </div>
              <div class="solids" v-if="imgList" :style="{display:imgList ? 'none' : 'block'}">
                <span class="cuIcon-cameraadd"></span>
              </div>
            </div>
          </div>

          <div class="com-input-handle">
            <div class="com-input-handle-right">
              <div class="c-i-h-r-forward">
                <van-checkbox checked-color="#FFBD0A" shape="square" v-model="checked">
                  <span>转发我的评论</span>
                </van-checkbox>
              </div>
              <div class="c-i-h-r-btn">
                <span @click="formSubmit" class="cu-btn bg-green shadow-blur cu-btn-fsbtn">发布</span>
              </div>
            </div>
            <input id="upload_file" ref="upload_file" type="file" style="display: none;" accept="image/*" name="file" @change="fileChange($event)" />
            <div class="com-input-handle-imgicon" @click="fileClick()">
              <img src="../../assets/images/dynamic_btn_pic_normal.png" />
            </div>
            <!--   <div class="com-input-handle-imgicon">
              <img src="../../assets/images/dynamic_btn_pic_disable.png" />
            </div>-->
          </div>
        </div>
      </form>
    </div>
    <!-- 新增 感兴趣的人 -->
    <div class="interestbox">
      <div class="indexes" style="border-bottom:1px solid #efefef">
        <span class="indexes-title">感兴趣的人</span>
        <span class="indexes-exr" @click="gotofindperson">
          查看更多
          <span></span>
        </span>
      </div>
      <div class="topiconbox">
        <div class="toppicicon" v-for="item in interestUser">
          <div>
            <img :src="item.avatar_url" />
          </div>
          <p v-if="item.name">{{item.name}}</p>
          <p v-else>默认昵称</p>
          <button class="circle-cell-fllow" v-if="item.is_follower == 0" @click="handleFocus" :data-id="item.id">关注</button>
          <button class="circle-cell-fllow circle-cell-fllow-active" v-else @click="handleFocus" :data-id="item.id">已关注</button>
        </div>
      </div>
      <div v-if="hotMsg.length != 0" class="indexes">
        <span class="indexes-title">大家都在看</span>
      </div>
      <div class="findbigbox" ref="findbigbox">
        <div v-for="(item,index) in hotMsg" :key="index">
          <div class="findcellbox">
            <div class="findtempbox">
              <div class="findtempimgbox">
                <div v-if="item.extra" @click="gotocircledetails" :data-id="item.id">
                  <img class="thumb" style="width: 100%;" v-lazy="item.thumb" />
                </div>
                <img v-if="!item.extra" @click="gotocircledetails" :data-id="item.id" :src="tou" />
                <div v-if="item.msg_type == 2" class="videoicon">
                  <img :src="findIconPlay" />
                </div>
                <div class="authtitlebox">
                  <div class="authtitle-left">
                    <img v-if="item.user_avatar_url" :src="item.user_avatar_url" />
                    <img v-else :src="avatar_url" />
                  </div>
                  <div class="authtitle-right">
                    <img :src="findIconApplause" />
                    <span>{{item.nices_num}}</span>
                  </div>
                </div>
              </div>
              <div class="findtemptitlebox">
                <div class="findtemptext">{{item.content}}</div>
                <div class="findtitile-downbox">
                  <div v-if="item.is_follow == 0" class="authorfllow" @click="favorclick" :data-id="item.id">
                    <button>
                      <span class="cuIcon-add"></span>关注
                    </button>
                  </div>
                  <div v-if="item.is_follow == 1" class="authorfllow unfollow" @click="favorclick" :data-id="item.id">
                    <button>已关注</button>
                  </div>
                  <div class="authorbox" @click.stop="gotocirclecontent" :data-id="item.like_id">
                    <img :src="dynamicIconQz" />
                    <span>{{item.like_title}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import Vue from "vue";
import { Overlay, Toast, ImagePreview } from "vant";

Vue.use(Toast);
Vue.use(Overlay);
Vue.use(ImagePreview);
import { getmymessage, getcomment, getclickfollow, gettofollowcircle } from "../../api/api";
import ddetailstop from "../public/ddetailstop";
import navbar from "../public/navbar.vue";
import comment from "../public/comment";
import recomment from "../public/recomment";
import { mapState } from "vuex";

//输入框变大
var bigtextclick = 0;

export default {
  components: { ddetailstop, navbar, comment, recomment },
  data () {
    return {
      dqdtid: "", //动态id
      listindex: "",
      circleid: "",
      titlename: "动态详情",
      checked: false,
      messageList: [],
      commentList: [],
      hotMsg: [],
      interestUser: [],
      pageCount: 0,
      toName: "",
      api_uid: "",
      showsmallinput: true,
      show: false,
      content: "",
      to_uid: "",
      cid: "",
      imgList: "",
      datas: new FormData(),
      files: 0,
      isPidInfo: false,
      textareaheight: 100,
      guideIconSlider: require("../../assets/images/guide_icon_slider.png"),
      findIconApplause: require("../../assets/images/find_icon_applause.png"),
      findIconPlay: require("../../assets/images/find_icon_play.png"),
      dynamicIconQz: require("../../assets/images/dynamic_icon_qz.png"),
      inputHeadImg: require("../../assets/images/dynamic_btn_expand_normal.png"),
      avatar_url: require("../../assets/images/moren.jpg")
    };
  },
  watch: {
    $route: function (to, from) {
      //执行数据更新查询
      this.dqdtid = this.$route.query.id;
      this.initMyMssage(this.dqdtid);
    }
  },
  computed: {
    ...mapState(["baseAPI"])
  },
  // beforeRouteEnter(to, from, next) {
  //     if (from.name == 'dynamic') { // 这个name是下一级页面的路由name
  //       if (!from.meta.keepAlive) {
  //         from.meta.keepAlive = true; //当我们进入到C时开启B的缓存
  //       }
  //       next()

  //     }
  //     next()
  //     //to.meta.keepAlive = true;
  // },
  created () {
    window.scrollTo(0, 0);
    document.title = "动态详情";
    this.dqdtid = this.$route.query.id;
    this.listindex = this.$route.query.index;
    this.circleid = this.$route.query.circleid;
    this.initMyMssage(this.dqdtid);
  },
  methods: {
    //关注
    goodFocus: function (item_id) {
      var that = this;
      var show; //传递到数据库点赞的状态
      //var cookie_mid = wx.getStorageSync('Focus') || [];
      var cookie_mid = this.$store.getters.getFocus || []; //获取全部点赞的mid
      var newmessage = [];
      for (var i = 0; i < that.interestUser.length; i++) {
        if (that.interestUser[i].id == item_id) {
          console.log('111')
          //遍历找到对应的id
          var isshow; //点赞的状态
          if (cookie_mid.includes(item_id) || that.interestUser[i].is_follower == 1) {
            //说明已经点过赞,取消赞
            for (var j = 0; j < cookie_mid.length; j++) {
              if (cookie_mid[j] == item_id) {
                cookie_mid.splice(j, 1); //删除取消赞的mid
              }
            }
            isshow = 0; //点赞的状态
            that.interestUser[i].is_follower = isshow;
            that.$store.dispatch("changeFocusFun", cookie_mid);
          } else {
            isshow = 1; //点赞的状态
            that.interestUser[i].is_follower = isshow;
            cookie_mid.unshift(item_id); //新增赞的mid
            that.$store.dispatch("changeFocusFun", cookie_mid);
          }
          getclickfollow(item_id).then(res => {
           if (res.code == 200) {
              Toast("操作成功!");
            } else {
              Toast("操作失败!");
            }
          });
        }
      }
    },
    //关注他人
    handleFocus: function (e) {
      var item_id = e.currentTarget.dataset.id; //此处找到列表的id
      this.goodFocus(item_id);
    },
    gotocircledetails: function (e) {
      this.initMyMssage(e.currentTarget.dataset.id);
      window.scrollTo(0, 0)
    },
    //关注圈子和取消关注圈子
    goodfllow: function (id) {
      var that = this;
      var like_id = ""; //圈子id
      var cookie_mid = this.$store.getters.getZan || []; //获取全部点赞的id

      var newmessage = [];
      for (var i = 0; i < that.hotMsg.length; i++) {
        if (that.hotMsg[i].id == id) {
          //遍历找到对应的id
          like_id = that.hotMsg[i].like_id;
          if (cookie_mid.includes(id) || that.hotMsg[i].is_follow) {
            //说明已经关注过,取消关注
            for (var k = 0; k < that.hotMsg.length; k++) {
              if (that.hotMsg[k].like_id == like_id) {
                for (var j = 0; j < cookie_mid.length; j++) {
                  if (cookie_mid[j] == that.hotMsg[k].id) {
                    cookie_mid.splice(j, 1); //删除取消赞的mid
                  }
                }
                that.$store.dispatch("changeZanFun", cookie_mid);
                that.hotMsg[k].is_follow = 0; //其他同个人的也取消关注
              }
            }
          } else {
            for (var k = 0; k < that.hotMsg.length; k++) {
              if (that.hotMsg[k].like_id == like_id) {
                that.hotMsg[k].is_follow = 1; //其他同个人的也关注
                cookie_mid.unshift(that.hotMsg[k].id); //新增赞的mid
              }
            }
            that.$store.dispatch("changeZanFun", cookie_mid);
          }

          gettofollowcircle(like_id).then(res => {
            if (res.code == 200) {
              Toast("操作成功!");
            } else {
              Toast("操作失败!");
            }
          });
        }
      }
    },
    favorclick: function (e) {
      var id = e.currentTarget.dataset.id; //此处找到列表的id
      this.goodfllow(id);
    },
    gotofindperson: function () {
      this.$router.push({
        name: 'findperson'
      })
    },
    verify: function () {
      var content = this.content;
      if (content.length > 499) {
        Toast("内容文字不可以超过500个字");
      }
    },
    //
    bigtextarea () {
      let windowHeight = document.documentElement.clientHeight - 110; // 屏幕的高度
      /*       let isIphoneX = this.data.isIphoneX;
      if (isIphoneX) {
        windowHeight = windowHeight - 20
      } */

      if (bigtextclick % 2 == 0) {
        this.textareaheight = windowHeight;
        this.inputHeadImg = require("../../assets/images/dynamic_btn_expand_selected.png");
      } else {
        this.textareaheight = 100;
        this.inputHeadImg = require("../../assets/images/dynamic_btn_expand_normal.png");
      }

      bigtextclick++;
    },
    //调用相册&相机
    fileClick () {
      this.$refs.upload_file.click();
    },
    fileChange (el) {
      this.files = this.$refs.upload_file.files[0].name;
      for (let i = 0; i < this.files.length; i++) {
        this.datas.append("file", this.files[i]);
      }
      this.show1 = false;
      if (!el.target.files[0].size) return;
      this.fileList(el.target);
      el.target.value = "";
    },
    fileList (fileList) {
      let files = fileList.files;
      for (let i = 0; i < files.length; i++) {
        //判断是否为文件夹
        if (files[i].type != "") {
          this.fileAdd(files[i]);
        } else {
          //文件夹处理
          this.folders(fileList.items[i]);
        }
      }
    },
    //文件夹处理
    folders (files) {
      let _this = this;
      //判断是否为原生file
      if (files.kind) {
        files = files.webkitGetAsEntry();
      }
      files.createReader().readEntries(function (file) {
        for (let i = 0; i < file.length; i++) {
          if (file[i].isFile) {
            _this.foldersAdd(file[i]);
          } else {
            _this.folders(file[i]);
          }
        }
      });
    },
    fileAdd (file) {
      var that = this;
      //判断是否为图片文件
      if (file.type.indexOf("image") != -1) {
        let reader = new FileReader();
        reader.vue = this;
        reader.readAsDataURL(file);
        reader.onload = function () {
          file.src = this.result;
          var img = new Image();

          img.onload = function () {
            // 当图片宽度超过 400px 时, 就压缩成 400px, 高度按比例计算
            // 压缩质量可以根据实际情况调整
            var w = Math.min(200, img.width);
            var h = img.height * (w / img.width);
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");

            // 设置 canvas 的宽度和高度
            canvas.width = w;
            canvas.height = h;

            // 把图片绘制到 canvas 中
            ctx.drawImage(img, 0, 0, w, h);

            // 取出 base64 格式数据
            var dataURL = canvas.toDataURL("image/png");
            var base64String = dataURL;
            //这里对base64串进行操作，去掉url头，并转换为byte
            var bytes = window.atob(base64String.split(",")[1]);

            //处理异常，将ASCII码小于0的转换为大于0，这里有两种写法

            var ab = new ArrayBuffer(bytes.length);
            var ia = new Uint8Array(ab);
            for (var i = 0; i < bytes.length; i++) {
              ia[i] = bytes.charCodeAt(i); //这里有点疑惑，ia是怎么改变ab的？注：①
            }
            //Blob对象
            var blob = new Blob([ab], { type: "image/jpeg" }); //type为图片的格式

            //FormData对象
            var formData = new FormData();

            let baseURL = that.baseAPI;

            formData.append("file", blob, Date.now() + ".jpg");
            //上传
            axios.defaults.headers.common["PLATFORM"] = "H5";
            axios.defaults.timeout = 30000;
            const instance = axios.create({
              withCredentials: false
            });
            instance
              .post(baseURL + "/file-bases/images", formData)
              .then(res => {
                that.imgList = res.data.data.url;
              })
              .catch(function (error) {
              });

            // ...
          };

          img.src = this.result;
        };
      }
    },
    //获得模板列表
    initMyMssage (id) {
      let that = this;
      let page = 0;

      getmymessage(id)
        .then(res => {
          if (res.data.code == 200) {
            that.messageList = res.data.data;
            that.commentList = res.data.data.commentList;
            that.interestUser = res.data.data.interestUser;
            this.interestUser.filter(item => {
              if (item.name.length > 3) {
                item.name = item.name.slice(0, 3) + "...";
              }
            });
            that.hotMsg = res.data.data.hotMsg;
            that.pageCount = res.data.data.pageCount;
            that.toName = res.data.data.name;
            that.api_uid = res.data.data.api_uid;
            if (that.messageList.pid_info.length != 0) {
              that.isPidInfo = true;
            } else {
              that.isPidInfo = false;
            }
          } else {
          }
        })
        .catch(err => {
        });
    },
    //评论栏升起
    upCommentbig (e) {
      this.toName = e.currentTarget.dataset.toname;
      if (e.currentTarget.dataset.cid) {
        this.cid = e.currentTarget.dataset.cid;
        this.to_uid = e.currentTarget.dataset.uid;
      }
      this.show = true;
      this.showsmallinput = false;
    },
    //关闭评论
    closecomment () {
      this.show = false;
      this.showsmallinput = true;
      this.content = "";
      this.imgList = "";
      this.to_uid = "";
      this.cid = "";
      this.toName = "";
    },
    //提交表单及关闭评论栏
    formSubmit (e) {
      let that = this;
      let dqdtid = this.dqdtid; //动态id
      let msg_id = this.messageList.id;
      let send_msg = this.checked ? "1" : "0";
      let content = this.content;
      let extra = this.imgList;

      if (extra == '' && content == '') {
        Toast("评论不能为空！");
        return;
      }

      //回复评论才需
      let to_uid = this.to_uid; //回复谁
      let cid = this.cid; //主评论

      getcomment(msg_id, to_uid, cid, content, extra, send_msg)
        .then(res => {
          if (res.code == 200) {
            Toast.success("评论成功");
            that.initMyMssage(dqdtid);
          } else {
            Toast.fail({
              message: res.message,
              duration: 1000
            });
          }
        })
        .catch(err => {
        });
      that.checked = false;
      that.content = "";
      that.imgList = "";
      that.to_uid = "";
      that.cid = "";
      that.toName = "";
      that.page = 0;
      that.showsmallinput = true;
      that.show = false;
      that.page = 0;
    },
    ViewImage (e) {
      ImagePreview([e.currentTarget.dataset.url]);
    },
    DelImg () {
      this.imgList = "";
    }
  }
};
</script>

<style scoped>
.commentbox {
  background: #fff;
  overflow: hidden;
}
.commentbox .commenthead {
  overflow: hidden;
  border-bottom: 1px solid #efefef;
  padding: 0.945946rem 0.675676rem 0.410811rem 0.675676rem;
}
.commentbox .commenthead .commenthead-tx {
  float: right;
}

.cu-avatar-group {
  /*  unicode-bidi: bidi-override;
  background: #ff00; */
  float: left;
  /*   display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start; */
  direction: rtl;
  unicode-bidi: bidi-override;
  display: inline-block;
  position: relative;
  top: -0.3rem;
}

.cu-avatar-group .touxiangzu {
}

.commentbox .commenthead .commenthead-tx span {
  float: left;
  color: #999;
  font-size: 0.7567567567567568rem;
  padding-right: 24px;
}
.commentbox .commenthead .commenthead-tx .touxiangzu {
  display: inline-flex;
  position: relative;
  background-size: cover;
  background-position: center;
  vertical-align: middle;
  width: 1.162162162162162rem;
  height: 1.162162162162162rem;
  margin-left: -0.5405405405405406rem;
  border-radius: 50%;
}
.commentbox .commenthead .commenthead-num {
  font-size: 0.7567567567567568rem;
}
.commentbox .commentbody {
  padding-bottom: 2.7027027027027026rem;
}

/*--评论--*/

.commentbox .commentinputbox {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 10;
  background: #fff;
  padding: 0.5rem;
  margin-top: 0.5rem;
  border-top: 1px solid #efefef;
}
.commentbox .commentinputbox .cu-barbox {
  padding-left: 0.2702702702702703rem;
  padding-right: 0.8108108108108109rem;
}
.commentbox .commentinputbox .cu-barbox .wztext {
  color: #888;
  display: inline-block;
  width: 12.972972972972974rem;
  float: left;
  font-size: 0.8rem;
  margin-left: 0.7rem;
  padding-top: 0.23rem;
}
.commentbox .commentinputbox .cu-barbox .cu-bar-imgicon {
  width: 1.3513513513513513rem;
  height: 1.0810810810810811rem;
  background-color: #fff;
  float: left;
  margin-left: 0.1rem;
  margin-top: 0.3rem;
}
.commentbox .commentinputbox .cu-barbox .cu-bar-imgicon img {
  width: 1.3513513513513513rem;
  height: 1.0810810810810811rem;
}
.commentbox .commentinputbox .cu-barbox .cu-btn-fsbtn {
  width: 3.135135135135135rem;
  height: 1.7297297297297298rem;
  float: right;
  margin-right: 0.2rem;
  border-radius: 1.0810810810810811rem;
  border: none;
  color: #fff;
  font-size: 0.72rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
}

/*--评论大--*/
.commentinputmain {
  background: rgba(255, 255, 255, 1);
  position: fixed;
  width: 100%;
  z-index: 51;
  overflow: hidden;
  bottom: 0;
}
.commentinputmain .com-input-head {
  padding-left: 0.8108108108108109rem;
  padding-right: 0.8108108108108109rem;
  overflow: hidden;
  padding-top: 0.7567567567567568rem;
  padding-bottom: 0.8108108108108109rem;
}
.commentinputmain .com-input-head .com-input-head-img {
  float: right;
}
.commentinputmain .com-input-head .com-input-head-img img {
  width: 0.8108108108108109rem;
  height: 0.8108108108108109rem;
}
.commentinputmain .com-input-head .com-input-head-text01 {
  color: #666;
  padding-right: 0.2702702702702703rem;
  font-size: 0.7027027027027027rem;
}
.commentinputmain .com-input-head .com-input-head-text02 {
  color: #333;
  font-size: 0.7027027027027027rem;
}
.commentinputmain .com-input-textarea {
  padding-left: 0.8108108108108109rem;
  font-size: 0.7567567567567568rem;
  clear: both;
  overflow: hidden;
  padding-right: 0.8108108108108109rem;
  padding-bottom: 0.2702702702702703rem;
}
.commentinputmain .com-input-textarea textarea {
  width: 100%;
  font-family: "微软雅黑";
  border: none;
}
.commentinputmain .com-input-handle {
  padding-left: 0.8108108108108109rem;
  padding-right: 0.8108108108108109rem;
  overflow: hidden;
  padding-bottom: 1.0810810810810811rem;
}
.commentinputmain .com-input-handle .com-input-handle-right {
  float: right;
}
.commentinputmain .com-input-handle .com-input-handle-right .c-i-h-r-btn {
  float: left;
}
.commentinputmain
  .com-input-handle
  .com-input-handle-right
  .c-i-h-r-btn
  .cu-btn-fsbtn {
  display: inline-block;
  text-align: center;
  width: 3.135135135135135rem;
  height: 1.7297297297297298rem;
  line-height: 1.7297297297297298rem;
  border-radius: 1.0810810810810811rem;
  background: linear-gradient(to right, rgb(255, 189, 10), rgb(248, 218, 91));
  border: none;
  color: #fff;
  font-size: 0.72rem;
}
.commentinputmain .com-input-handle .com-input-handle-right .c-i-h-r-forward {
  float: left;
  padding-right: 1.3513513513513513rem;
  padding-top: 0.2702702702702703rem;
}

.commentinputmain
  .com-input-handle
  .com-input-handle-right
  .c-i-h-r-forward
  span {
  float: left;
  padding-left: 0.5405405405405406rem;
  padding-top: 0.08108108108108109rem;
  font-size: 0.7027027027027027rem;
}
.commentinputmain .com-input-handle .com-input-handle-imgicon {
  float: left;
  padding-top: 0.2702702702702703rem;
}
.commentinputmain .com-input-handle .com-input-handle-imgicon img {
  width: 1.3513513513513513rem;
  height: 1.0810810810810811rem;
}
.commentinputmain .cu-form-group {
  min-height: auto;
  padding-left: 0.8108108108108109rem;
  padding-right: 0.8108108108108109rem;
  padding-bottom: 0.2702702702702703rem;
}
.commentinputmainbg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 50;
}
.grid.col-4.grid-square > div {
  padding-bottom: calc((100% - 1.6216216216216217rem) / 4);
  height: 0;
  width: calc((100% - 1.6216216216216217rem) / 4);
  position: relative;
}
.grid.col-4.grid-square > div > img {
  width: 100%;
  height: 4.19rem;
}
.grid.grid-square .cu-tag {
  width: 1.248649rem !important;
  height: 1.248649rem !important;
  position: absolute;
  right: 0;
  top: 0;
  border-bottom-left-radius: 0.16216216216216217rem;
  height: auto;
}

.topiconbox {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  padding: 1.25rem 0.5rem;
  width: calc(100% - 1rem);
  margin: 0 auto;
  background: #fff;
}
.topiconbox .toppicicon {
  flex: 0 0 20%;
}
.topiconbox .toppicicon img {
  width: 2.6rem;
  height: 2.6rem;
  border-radius: 50%;
  margin: 0 auto !important;
  display: block;
}
.topiconbox .toppicicon p {
  text-align: center;
  display: block;
  color: #af7018;
  font-size: 0.7567567567567568rem;
  padding: 0.32rem 0;
}
.circle-cell-fllow {
  font-size: 0.6216216216216216rem;
  background: #ffbd0a;
  border: none;
  width: 3rem;
  height: 1.15rem;
  border-radius: 5px;
  display: block;
  color: #fff;
  padding: 0;
  margin: 0 auto;
}
.circle-cell-fllow-active {
  color: #ffbd0a;
  background: #fff;
  border: 1px solid #ffbd0a;
}
.interestbox {
  padding-bottom: 2.7027027027027026rem;
}
.interestbox .indexes {
  padding: 0.7rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 0.40540540540540543rem solid #f8f8f8;
}
.interestbox .indexes .indexes-title {
  display: inline-block;
  line-height: 0.75rem;
  padding: 0 0.5rem;
  font-size: 0.8108108108108109rem;
  border-left: 3px solid #ffbd0a;
}
.interestbox .indexes .indexes-exr {
  font-size: 0.7567567567567568rem;
  color: #999;
}
.interestbox .indexes .indexes-exr > span {
  display: inline-block;
  width: 0.3rem;
  height: 0.3rem;
  border-top: 1px solid #999;
  border-right: 1px solid #999;
  transform: rotate(45deg);
  position: relative;
  top: -0.15rem;
}
.findbigbox {
  column-count: 2;
  column-gap: 0.05405405405405406rem;
  width: 96%;
  padding-left: 2%;
}
.findbigbox .findcellbox {
  width: 96%;
  background: #fefefe;
  margin-top: 0.5405405405405406rem;
  padding: 0.02702702702702703rem;
  padding-bottom: 0.13513513513513514rem;
  transition: opacity 0.4s ease-in-out;
  display: inline-block;
  margin-right: 4%;
  border-radius: 0.2702702702702703rem;
}
.findtempbox {
}
.findtempbox .findtempimgbox {
  position: relative;
}
.findtempbox .findtempimgbox .thumb {
  width: 100%;
  max-height: 13.513513513513514rem;
  min-height: 10rem;
  border-top-left-radius: 0.2702702702702703rem;
  border-top-right-radius: 0.2702702702702703rem;
}
.findtempbox .findtempimgbox .videoicon {
  position: absolute;
  top: 0.5405405405405406rem;
  right: 0.4864864864864865rem;
}
.findtempbox .findtempimgbox .videoicon img {
  width: 1.5135135135135136rem;
  height: 1.5135135135135136rem;
}
.findtempbox .findtempimgbox .authtitlebox {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.findtempbox .findtempimgbox .authtitlebox .authtitle-left {
  float: left;
  padding-left: 0.5405405405405406rem;
  padding-bottom: 0.2702702702702703rem;
}
.findtempbox .findtempimgbox .authtitlebox .authtitle-left img {
  border-radius: 50%;
  width: 1.2432432432432432rem;
  height: 1.2432432432432432rem;
  border: 0.08108108108108109rem solid #fff;
}
.findtempbox .findtempimgbox .authtitlebox .authtitle-right {
  float: right;
  text-align: right;
  padding-right: 0.5405405405405406rem;
  padding-top: 0.13513513513513514rem;
}
.findtempbox .findtempimgbox .authtitlebox .authtitle-right img {
  width: 0.918918918918919rem;
  height: 0.972972972972973rem;
  margin-bottom: -0.08108108108108109rem;
}
.findtempbox .findtempimgbox .authtitlebox .authtitle-right span {
  color: #f6f6f6;
  padding-left: 0.2702702702702703rem;
}
.findtempbox .findtemptitlebox {
  width: 92%;
  margin: 0 auto;
  background: #fff;
  padding-bottom: 0.5405405405405406rem;
}
.findtempbox .findtemptitlebox .findtemptext {
  padding-bottom: 0.5405405405405406rem;
  font-size: 0.7027027027027027rem;
  color: #333;
}
.findtempbox .findtemptitlebox .findtitile-downbox {
  overflow: hidden;
}
.findtempbox .findtemptitlebox .findtitile-downbox .authorfllow {
  float: right;
}
.findtempbox .findtemptitlebox .findtitile-downbox .authorbox {
  float: left;
  width: 5.1rem;
  padding-top: 0.16216216216216217rem;
  font-size: 0.6486486486486487rem;
  /* overflow: hidden;
     text-overflow: ellipsis;
     white-space: nowrap;
     */
  color: #666;
}
.findtempbox .findtemptitlebox .findtitile-downbox .authorbox img {
  width: 0.918918918918919rem;
  height: 0.8918918918918919rem;
  margin-bottom: -0.13513513513513514rem;
}
.findtempbox .findtemptitlebox .findtitile-downbox .authorbox span {
  padding-left: 0.21027rem;
}
.findtempbox .findtemptitlebox .findtitile-downbox .authorfllow button {
  font-size: 0.5945945945945946rem;
  color: #ffbd0a;
  border: 1px solid #ffbd0a;
  width: 2.6486486486486487rem;
  display: block;
  padding: 0;
  background: #fff;
  outline: none;
  line-height: 1.0810810810810811rem;
  border-radius: 0.235135rem;
}
.findtempbox .findtemptitlebox .findtitile-downbox .unfollow button {
  color: #666;
  border: 1px solid #666;
}
.findtempbox .findtemptitlebox .findtitile-downbox .authorfllow button::after {
  border: none;
}
.findtempbox .findtemptitlebox .findtitile-downbox .authorfllow button.active {
  background: #dbdbdb;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/dynamicdetails.vue